import { render, staticRenderFns } from "./PerformanceRanking.vue?vue&type=template&id=2413e145"
import script from "./PerformanceRanking.vue?vue&type=script&lang=js"
export * from "./PerformanceRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports